<template>
  <div class="flex flex-col md:flex-row mt-4 pb-4">
    <div class="w-full md:w-1/3">
      <div v-if="item.entity_type == 'item'" class="flex">
        <div class="w-2/3 md:w-1/3 md:w-auto mx-4">
          <div class="item-img-container">
            <img :src="itemImage" alt="Item Image" />
          </div>
        </div>
        <div class="w-2/3 md:w-2/3 md:w-auto flex flex-col">
          <p class="leading-normal text-black font-bold text-lg pb-4">{{ itemName }}</p>
          <p v-if="itemDescription" class="pb-4 pr-2" style="color:#7d7d7d">{{ itemDescription }}</p>
          <p v-if="itemPrice">
            <i v-if="isBDPhoneNumber()" class="icon-ic icon-ic-taka" />
            <span v-else>रू</span>
            {{ itemPrice }}
          </p>
        </div>
      </div>
      <div v-else class="mx-4">
        <p class="leading-normal text-black font-bold text-lg pb-4">{{ itemName }}</p>
      </div>
    </div>
    <div class="flex w-full md:w-2/3 px-4 md:px-0">
      <div class="w-1/3 mr-2 mt-1">
        <p class="text-grey-darker font-normal mb-4">Requested Date</p>
        <p class="text-grey-darker font-bold">{{ item.requested_date }}</p>
      </div>
      <div class="w-1/3 mr-2 mt-1">
        <p class="text-grey-darker font-normal mb-4">Type of Change</p>
        <p class="text-grey-darker font-bold capitalize">{{ item.type_of_change }}</p>
      </div>
      <p class="w-1/3 text-red self-center underline cursor-pointer" @click.stop="showDetail">See Details</p>
    </div>
  </div>
</template>

<script>
import isBDPhoneNumber from '@src/utils/isBdNumber';
export default {
  name: 'ApprovalItem',
  props: {
    item: {
      type: Object,
      default: () => {},
    },
  },
  data() {
    return {
      upcomingChanges: this.item.changes.upcoming || {},
      currentChanges: this.item.changes.current || {},
    };
  },
  computed: {
    itemImage() {
      const image =
        (this.upcomingChanges && this.upcomingChanges.image) ||
        (this.currentChanges && this.currentChanges.image) ||
        null;
      return image || require('@assets/images/item.png');
    },
    itemName() {
      return (
        (this.upcomingChanges && this.upcomingChanges.name) || (this.currentChanges && this.currentChanges.name) || null
      );
    },
    itemPrice() {
      return (
        (this.upcomingChanges && this.upcomingChanges.price) ||
        (this.currentChanges && this.currentChanges.price) ||
        null
      );
    },
    itemDescription() {
      return (
        (this.upcomingChanges && this.upcomingChanges.description) ||
        (this.currentChanges && this.currentChanges.description) ||
        null
      );
    },
  },
  watch: {
    item(newValue) {
      this.upcomingChanges = newValue.changes.upcoming || {};
      this.currentChanges = newValue.changes.current || {};
    },
  },
  methods: {
    isBDPhoneNumber,
    showDetail() {
      this.$emit('showDetail', this.item);
    },
  },
};
</script>
